export default {
	sync: {
		// Shown when something open here was changed underneath it by someone else.
		projectDeleted: "This project was deleted by another user.",
		removedFromProject: "You are no longer a member of this project.",
		processDeleted: "This process was deleted by another user.",
		viewDeleted: "This view was deleted by another user.",
		actionDeleted: "This action was deleted by another user.",
		draft: {
			changed: "Someone else changed this while you were editing it.",
			changedBy: "{name} changed this while you were editing it.",
			changedByService: "The service token “{name}” changed this while you were editing it.",
			deleted: "This was deleted while you were editing it.",
			deletedBy: "{name} deleted this while you were editing it.",
			deletedByService: "The service token “{name}” deleted this while you were editing it.",
			keepMine: "Keep mine",
			takeTheirs: "Load their version",
		},
	},
};
